module.exports = __webpack_public_path__ + "static/media/Visa.349411f3.svg";